var jade = require("/app/app/assets/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div ng-if=\"!$ctrl.isLoaded\" class=\"loading-spinner in-progress\"></div><div ng-transclude ng-if=\"$ctrl.isLoaded\"><od-flip-dates></od-flip-dates></div>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./javascripts/common/components/od-flip-dates-container.jade
 ** module id = 690
 ** module chunks = 0 1 3 4 5 6
 **/